// Granted per-user in Core.UserEntitlements and enforced per-action by User.Api ([RequireEntitlement]
// on every write of the Access area) — keep this string in sync with the backend constant
// Framework.Authorization.EntitlementNames.AdminEntitlementsManage.
/**
 * Managing who can do what: entitlement groups, their members, and direct grants (the admin Access
 * area, seed ID 27). A SYSTEM entitlement — the Access UI can never assign, edit or revoke it; it
 * reaches a person only by DB script, which is what keeps its holders a deliberate list. Holding any
 * other admin entitlement does not imply it. See docs/Entitlement-Groups-Plan.md (D7, D8, D16).
 */
export const ENTITLEMENTS_MANAGE_ENTITLEMENT = 'Admin:Entitlements:Manage';
